import React from "react";
import { withTheme } from "@material-ui/core";
import {autorun} from "mobx";
import MapView, { Marker, DrawingTools, MapControls, Popup, MapConstant , MarkerLayer} from "../../../../lib/Map";
import MapsHelper from "../../../../lib/Map/helper";
import { TerminalMarker } from "../../../../components/mapComponents/Markers";
import { ShipmentPopupInfo, ZonePopUpInfo } from "../../../../components/mapComponents/Popups";
import { getShipmentMarker } from "../../../../components/mapComponents/mapHelper";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { observer, inject } from "mobx-react";
import appConstants from "@appConstants";
import { isEqual } from "lodash/lang";
import Events from "../../../../utilities/EventEmitter";
import LassoRoute from "../Common/LassoRoute";
import {withAppConfig} from "../../../../appConfigContext"
import { getSpecialNeedsOptionsWithServiceLevel } from "../../utils"

@inject('IBPlanningStore')
@observer
class MapsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.terminalLocation =this.props.userData.userProfile && this.props.userData.userProfile.terminal.location;
        this.state = {
            showTerminalPopup: false,
            shipmentsData: this.props.IBPlanningStore.filteredShipmentsOnMap,
            selectedShipment: null,
            themeChanged: true,
            currentTheme: this.props.theme.themeName,
            selectedShipmentList: [],
            mapCenter: this.props.userData.userProfile.terminal.location,
            zoneInfo:null,
            showLasso: false,
            lassoShipments:[],
            isNewLasso: false,
            styleName: null,
        }
        this.stackContainer = this.props.glContainer.parent.parent;
        this.mapRef = React.createRef();
        this.lassoBounds = [];
    }

    componentDidMount() {
        this.autorunDispose = autorun(()=>{
            if(!isEqual(this.state.selectedShipmentList.slice(),this.props.IBPlanningStore.selectedShipmentIDList.slice())){
                this.selectedShipmentChanged(this.props.IBPlanningStore.selectedShipmentIDList);
            }
        });

        this.autorunFilteredShipment = autorun(() =>{
            if(this.props.IBPlanningStore.filteredShipmentsOnMap.slice() && this.lassoBounds.length ){ // called when filteredShipmentsOnMap is set
                this.onScaleDrawingComplete(this.lassoBounds, false);
            }
        });
        this.props.glEventHub.on("filteredShipments", this.updateShipmentsInStore);
    }
    componentWillUnmount() {
        this.autorunDispose && this.autorunDispose();
        this.autorunFilteredShipment  && this.autorunFilteredShipment();
        this.props.IBPlanningStore.updateFilteredShipments();
        this.props.glEventHub.off("filteredShipments", this.updateShipmentsInStore);
    }

    updateShipmentsInStore=(shipmentsToUpdate)=>{
        this.selectedShipmentChanged(shipmentsToUpdate.map(shipment=>shipment.proId));
        this.setState({
            shipmentsData: shipmentsToUpdate
        })
    }
    static getDerivedStateFromProps(nextProps, state) {
        return {
            themeChanged: nextProps.theme.themeName !== state.currentTheme,
            currentTheme: nextProps.theme.themeName,
            mapCenter: nextProps.userData.userProfile.terminal.location,
            shipmentsData: nextProps.IBPlanningStore.filteredShipmentsOnMap
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id && this.state.showLasso){
            this.onLassoClose();
        }
    }

    onMapClicked = () => {
        this.hideAllPopups();
    }

    onTerminalClicked = ({ marker }) => {
        this.setState({
            terminalMarker: marker,
            selectedShipment: null,
            zoneInfo: null,
        })
    }

    onShipmentMarkerClicked = (shipment) => {
        const shipmentAlreadySelected = this.state.selectedShipmentList.includes(shipment.proId);

        const updatedSelectedShipments = shipmentAlreadySelected ? this.state.selectedShipmentList : [shipment.proId];
        this.props.glEventHub.emit("UpdateIBStore", "updateSelectedShipments", [updatedSelectedShipments]);
        this.props.glEventHub.emit(appConstants.Event.SHIPMENT_SELECTED_MAP, shipment.proId);

        this.setState({
            selectedShipment: {...shipment},
            terminalMarker: null,
            selectedShipmentList: shipmentAlreadySelected ? this.state.selectedShipmentList : [shipment.proId],
            zoneInfo: null,
        });
       
    }

    selectedShipmentChanged = (proIdList) => {
        let mapCenter = {};
        if (proIdList.length === 1) {
            const shipment = this.state.shipmentsData.find(shipment => shipment.proId === proIdList[0]);
            if(shipment){
                mapCenter = { lat: shipment.latitude, lng: shipment.longitude };
            }
        }
            this.setState((state) => ({
                selectedShipmentList: !isEqual(state.selectedShipmentList, proIdList) ? [...proIdList] : state.selectedShipmentList,
                selectedShipment: null,
                mapCenter,
                zoneInfo: null,
            }));
    }

    hideAllPopups = () => {
        this.setState({
            selectedShipment: null,
            terminalMarker: null,
            zoneInfo: null,
        });
    }

    isShipmentActive = (currentProId) => {
        return this.state.selectedShipmentList.find(proId => proId === currentProId);
    }

    onZoneClicked=(zoneInfo)=>{
        this.setState({
            selectedShipment: null,
            terminalMarker: null,
            zoneInfo,
        });
    }

    onScaleDrawingComplete = (bounds, isNewLasso = true) => {
       this.lassoBounds = bounds;
       const lassoShipments = MapsHelper.getLocationWithinBounds(bounds, this.state.shipmentsData);
       if(!isEqual(this.state.lassoShipments, lassoShipments) || !this.state.showLasso || this.state.isNewLasso !== isNewLasso || isNewLasso){
            if(!this.props.glContainer.parent.parent.isMaximised && !this.state.showLasso){
                this.props.glEventHub.emit("toggleQuickFilterVisibility", false);
            }

            this.setState({
                lassoShipments,
                showLasso: true,
                isNewLasso
            });
            this.mapRef.current.classList.add('mapContainerWithLasso');
       }

    }

    onLassoClose = () => {
        this.mapRef.current.classList.remove('mapContainerWithLasso');
        this.setState({
            showLasso: false,
            lassoShipments:[],
            isNewLasso:false
        });
        this.lassoBounds =[];
        this.props.glEventHub.emit("mapResize");
    }

    getShipmentIcon = (shipment) => {
        return getShipmentMarker({
            shipmentData : shipment,
            theme: this.props.theme,
            isActiveShipment: this.isShipmentActive(shipment.proId),
          });
    }

    getMarkerLayerCenter = () => {
        // If a single marker is slected on grid or on Map move map to make that shipment as center 
        const {selectedShipment, shipmentsData, selectedShipmentList} = this.state;
        if(selectedShipment){
            return { lat: selectedShipment.latitude, lng: selectedShipment.longitude }
        } else if(selectedShipmentList.length===1){
            const selShipment = shipmentsData.find(shipment => selectedShipmentList.includes(shipment.proId));
           if(selShipment){
            return { lat: selShipment.latitude, lng: selShipment.longitude }
           }
        }
        return null
    }

    getMapStyleName = (styleName) => {
        if (this.state.styleName !== styleName) {
          this.setState({ styleName: styleName });
        }
    };

    render() {
        const { theme } = this.props;
        this.terminalLocation =this.props.userData.userProfile && this.props.userData.userProfile.terminal.location;
        const {selectedShipment} = this.state;
        return (
            <div className="shipmentsMapContainer" ref={this.mapRef}>
                <MapView
                    zoom={11}
                    initialCenter={this.terminalLocation}
                    onClick={this.onMapClicked}
                    mapId={appConstants.mapIds.SHIPMENTS_MAP}
                    mapTheme={theme.themeName}
                    center={this.state.mapCenter}
                    eventHub={this.props.glEventHub}
                    mapConfig = {this.props.configJSON?.maps}
                    getMapStyleName={this.getMapStyleName}
                >

                    <Marker
                        position={this.terminalLocation}
                        onClick={this.onTerminalClicked}
                        animation
                        // anchor point is the point in the image which should overlap the location,
                        // Terminal image is of different size than the marker so we can override the default value as shown below
                        anchorPoint={{ x: 20, y: 20 }}
                        zIndex={1}
                        forceUpdate={true}
                        isActiveShipment={true}
                    >
                        <TerminalMarker data={this.props.userData.userProfile.terminal} color={theme.terminalContentColor}/>

                    </Marker>
                    <MarkerLayer
                        code={this.props.userData.userProfile.terminal.code}
                        data={this.state.shipmentsData.slice()}
                        dataKey={"proId"}
                        activeMarkerIds={this.state.selectedShipmentList.slice()}
                        getIcon={this.getShipmentIcon}
                        center={this.getMarkerLayerCenter()}
                        onClick={this.onShipmentMarkerClicked}
                        styleName={this.state.styleName}
                        showTooltip
                    />
                  

                    <DrawingTools
                        // options are controlled through header, DrawingToolbox
                        // Creates the map draw instance used by DrawingToolbox
                        eventHub={Events}
                        onDrawingComplete={this.onScaleDrawingComplete}
                        defaultThemeColor= {theme.commonAppHeaderTabColor}
                    />

                    <MapControls
                        controlOptions={
                            {
                                //  fullscreenControl: {
                                //      position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                                //  },
                                zoomControl: {
                                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                                },
                                satelliteViewControl: {
                                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                                },
                                reCenterMapControl: {
                                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                                },
                                showZones: {
                                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                                    terminalID: this.props.userData.userProfile.terminal.code,
                                    onZoneClicked: this.onZoneClicked,
                                    geoJson: this.props.userData.userProfile?.geoJson
                                }
                            }
                        }
                    />

                    {/* <Marker
                        position={this.terminalLocation}
                        onClick={this.onTerminalClicked}
                        animation
                        // anchor point is the point in the image which should overlap the location,
                        // Terminal image is of different size than the marker so we can override the default value as shown below
                        anchorPoint={{x:20,y:20}}
                        zIndex={5}
                    >
                        <TerminalMarker/>

                    </Marker>

                   { this.state.shipmentsData.length &&
                     this.state.shipmentsData.map(shipment => {
                         const isShipmentActive = this.isShipmentActive(shipment.proId);
                         return (
                            <Marker
                              data={shipment}
                              position={{ lat: shipment.latitude, lng: shipment.longitude }}
                              key={`${shipment.proId}`}
                              onClick={this.onShipmentMarkerClicked}
                              isActiveShipment = {isShipmentActive}
                              zIndex={isShipmentActive? 5 : 4} // display active shipments on top
                            >
                              { getShipmentMarker(shipment, isShipmentActive ? appConstant.Colors.markerActiveColor : null)}
                            </Marker>
                         )
                      })
                   }
                    */}
                    {this.state.selectedShipment && (
                        <Popup
                            // marker={this.state.selectedShipment.marker}
                            // forceRender will rerender the child component into the infowindow,
                            // set to true when theme changes or data is updated for selected shipment
                            position={{ lat: selectedShipment.latitude, lng: selectedShipment.longitude }}
                            forceRender={this.state.themeChanged}
                            key={`${this.state.selectedShipment.proId}_shipmentPopup`}
                        >
                            <ShipmentPopupInfo 
                             data={this.state.selectedShipment}
                             specialNeedsOptions={getSpecialNeedsOptionsWithServiceLevel(this.props.IBPlanningStore.serviceLevelList)}
                            />
                        </Popup>
                    )}

                    {/* {this.state.terminalMarker && (
                        <Popup
                            marker={this.state.terminalMarker}
                            // forceRender will rerender the child component into the infowindow,
                            // set to true when theme changes or data is updated for Terminal
                            forceRender={this.state.themeChanged}
                        >
                            <TerminalPopupInfo data={this.props.userData.userProfile.terminal} theme={this.props.theme.themeName} />
                        </Popup>
                    )} */}
                    {
                        this.state.zoneInfo  && (<Popup isCloseButton
                            position={this.state.zoneInfo.position}>
                            <ZonePopUpInfo data={this.state.zoneInfo.data}/>
                        </Popup>)
                    }

                </MapView>
               {this.state.showLasso && (
                   <LassoRoute
                        open={this.state.showLasso}
                        container={this.stackContainer.element[0]}
                        shipments={this.state.lassoShipments}
                        onClose={this.onLassoClose}
                        scenarioId={this.props.userData.userProfile.scenarioID}
                        currentView={"Shipments"}
                        isNewLasso={this.state.isNewLasso}
                        glEventHub={this.props.glEventHub}
                        mapId={appConstants.mapIds.SHIPMENTS_MAP}
                    />
               )}
            </div>
        )
    }
}
export default compose(withTheme(), withUserProfile,withAppConfig)(MapsComponent);
